<div class="ui container" appMargin appPadding paddingB='30'>


    <div class='ui vertical basic segment' [ngClass]="{'loading':pending}">
        <div fxLayout="row" fxLayoutAlign='space-between center'>
            <div fxLayout='row' fxLayoutGap='20px' (click)="goBack()" class="link">
                <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div>
                <div class='equipment-id'>
					<!-- Title -->
                    <h2 class="ui primary header">New Document Template</h2>
                </div>
            </div>

              <div fxLayout='row' fxLayoutGap='15px'>

					<button class="ui basic small  primary  button" (click)="goBack()" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="cancel template creation">
						Cancel
						</button>

					<button class="ui small  primary  button" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="save template">
						Save
						</button>
					</div>

		</div>
		<div class="ui divider" appMargin marginY="3"></div>
    <div *ngIf="success || error">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>

    </div>

		<div fxLayout="row" fxLayoutGap='50px'>
				<div class="ui form side-panel" fxFlex="30%" appPadding="15px">

					<div class="field">
						<label>Title</label>
						<input type="text" placeholder="Please enter title"/>
						</div>
								<div class="field">
						<label>Description</label>
						<textarea row="3" placeholder="Please enter description"></textarea>
						</div>
				</div>
				<div fxFlex="grow">
					<div fxLayout="row" fxLayoutAlign='space-between center'>
						<h3 appMargin marginB="0">Document Sections</h3>
						<button class="ui tiny button" >
							<i class="plus icon"></i>
							</button>
						</div>
						<hr>


						<div class="ui vertical basic segment">


						</div>

				</div>
			</div>

</div>
